export default {
    SET_LMS_USER_LIST: function(state, lmsUserList){
        state.lmsUserList = lmsUserList;
    },
    ADD_LMS_USER: function(state, roomUser){
        state.lmsUserList.push({
            userId: roomUser.userId,
            username: roomUser.username,
        });
    },
    DELETE_LMS_USER: function(state, roomUser){
        state.lmsUserList = state.lmsUserList.filter(lmsUser => lmsUser.userId !== roomUser.userId);
    }
}
